<py-forgot-password-form
  [error]="error$ | async"
  [success]="success$ | async"
  [loading]="loading$ | async"
  [resetPasswordEmailUserInputCheck]="resetPasswordEmailUserInputCheck$ | async"
  (emailCheck)="checkEmail($event)"
  (completed)="requestReset($event)"
>
</py-forgot-password-form>
